import { AutocompleteInput, SelectInput } from 'react-admin';
import { path } from './constants';
import { CountyInputProps } from './types';
import useController from './useController';

const CountyInput = ({ combobox = false, state, ...props }: CountyInputProps) => {
  const { counties, isDisabled } = useController({ state });
  const Input = combobox ? AutocompleteInput : SelectInput;

  return <Input choices={counties} disabled={isDisabled} optionValue="name" source={path('county')} {...props} />;
};

export default CountyInput;
